// extracted by mini-css-extract-plugin
export var drawerPaper = "_1a-0";
export var itemCard = "_1a-1";
export var itemImage = "_1a-2";